{
  "PAGINATION_FOOTER": {
    "SHOWING": "Showing {startItem} - {endItem} of {totalItems} items",
    "CURRENT_PAGE_INFO": "{currentPage} of {totalPages} pages"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Select an option...",
    "EMPTY_SEARCH_RESULTS": "No items found for the search term `{searchTerm}`",
    "EMPTY_STATE": "Không tìm thấy kết quả.",
    "SEARCH_PLACEHOLDER": "Search...",
    "MORE": "+{count} more"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Search...",
    "EMPTY_STATE": "Không tìm thấy kết quả.",
    "SEARCHING": "Đang tìm kiếm..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "Huỷ",
      "CONFIRM": "Xác nhận"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Search country",
    "ERROR": "Phone number should be empty or in E.164 format",
    "DIAL_CODE_ERROR": "Please select a dial code from the list"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Author is not available"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Breadcrumb"
  },
  "SWITCH": {
    "TOGGLE": "Toggle switch"
  },
  "LABEL": {
    "TAG_BUTTON": "tag"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Tìm hiểu thêm",
    "WATCH_VIDEO": "Watch video"
  },
  "DURATION_INPUT": {
    "MINUTES": "Phút",
    "HOURS": "Giờ",
    "DAYS": "Ngày",
    "PLACEHOLDER": "Nhập thời lượng"
  }
}
